import { render, staticRenderFns } from "./BankSelection.vue?vue&type=template&id=9ff64b3e&scoped=true&"
import script from "./BankSelection.vue?vue&type=script&lang=js&"
export * from "./BankSelection.vue?vue&type=script&lang=js&"
import style0 from "./BankSelection.vue?vue&type=style&index=0&id=9ff64b3e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff64b3e",
  null
  
)

export default component.exports